module.exports = __webpack_public_path__ + "static/media/web3.f9231bcd.jpg";